import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import React from 'react';
import { ContactContextType } from '../contexts/ContactContext';
import { VendorContextType } from '../contexts/VendorContext';

 

export interface PagingObj {
    totalRecords: number;
    totalPages: number;
    current: number;
    records: string;
}

// Create a centralized Axios instance
const apiInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT, // Specify your base URL
    withCredentials :true
    // You can add other default configurations here
});

enum Method {
    get = "GET",
    post = "POST"
}
export interface RequestConfig {
    url: string;
    method: Method,
}


export interface ApiRequest{
    requestType:RequestConfig
    data?:object,
    params?:object
    urlParams?: { [key: string]: string }
    secondTry?:boolean
}



export const RequestConfigs =  {
    createSession: {
        url: "/create-session",
        method: Method.post
    },
    login: {
        url: "/login",
        method: Method.post
    },
    vendorLogin: {
        url: "/vendor-login",
        method: Method.post
    },
    vendorSearchMember: {
        url: "/vendor/check-member",
        method: Method.get
    },
     subscribe: {
        url: "/subscribe",
        method: Method.post
    },
    dictionary: {
        url: "/dictionary",
        method: Method.get
    },
    addToCart: {
        url: "/add-to-cart",
        method: Method.post
    },
    mainProducts: {
        url: "/products/main",
        method: Method.get
    },
    productExtensions: {
        url: "/products/extensions",
        method: Method.get
    },
    sale: {
        url: "/contact/sale",
        method: Method.post
    },
    logout: {
        url: "/contact/logout",
        method: Method.post
    },
     vendorLogout: {
        url: "/vendor/logout",
        method: Method.post
    },
    updateContact: {
        url: "/contact/update",
        method: Method.post
    },
  
    getNotifications: {
        url: "/contact/notifications",
        method: Method.get
    },
    readNotification: {
        url: "/contact/notifications/read",
        method: Method.post
    },
    getAppointment: {
        url: "/contact/appointments",
        method: Method.get
    },
    getCases: {
        url: "/contact/cases",
        method: Method.get
    },
    getCasesAttachments: {
        url: "/contact/cases/:caseId/attachments",
        method: Method.get
    },
     getContactAttachments: {
        url: "/contact/contacts/attachments",
        method: Method.get
    },
    createCase: {
        url: "/contact/cases",
        method: Method.post
    },
    updateCase: {
        url: "/contact/cases/update",
        method: Method.post
    },
 

    cancelCase: {
        url: "/contact/cases/cancel",
        method: Method.post
    },
    cancelAppointment: {
        url: "/contact/appointments/cancel",
        method: Method.post
    },
    createAppointment: {
        url: "/contact/appointments",
        method: Method.post
    },

    getInvoices: {
        url: "/contact/invoices",
        method: Method.get
    },
    downloadInvoice: {
        url: "/contact/invoices/:id",
        method: Method.get
    },
    
    getFamily: {
        url: "/contact/family-members",
        method: Method.get
    },
    createFamilyMember: {
        url: "/contact/family-members/create",
        method: Method.post
    },
    updateFamilyMember: {
        url: "/contact/family-members/update",
        method: Method.post
    },
    deleteFamilyMember: {
        url: "/contact/family-members/delete",
        method: Method.post
    },
    switchMember: {
        url: "/contact/switch-member",
        method: Method.post
    },
    register: {
        url: "/register",
        method: Method.post
    },
    socialAuth: {
        url: "/social-auth",
        method: Method.post
    },

    
}




export async function createSession(){
    await apiInstance.post(RequestConfigs.createSession.url,{
        language: process.env.REACT_APP_DEFAULT_LANG,
        token: process.env.REACT_APP_TOKEN,
    })

}

export const downloadFile = async (fileUrl:string,name?:string) => {
    const fileName = name || "test.pdf"
    try {
      const response = await apiInstance({
        url: fileUrl,
        method: 'GET',
        responseType: 'blob',
      });
  
      const file = new Blob([response.data], { type: 'application/octet-stream' });
      const fileURL = URL.createObjectURL(file);
  
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
  
      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle error
    }
  };



export async function apiCall(
    { requestType, data, params,urlParams, secondTry }: ApiRequest,
    setGlobalLoading: React.Dispatch<React.SetStateAction<boolean>>,
    contactContext:ContactContextType,
    vendorContext:VendorContextType,
    navigate?:(route:string)=>void,
): Promise<ApiResponse | null> {
    const { method, url } = requestType;
    if(method===Method.get){
        params={...params,...data}
    }
   
    let serverRespond: ApiResponse | null = null;

    const finalUrl:string = urlParams ? Object.keys(urlParams).reduce((acc, key) => acc.replace(`:${key}`, urlParams[key]), url) : url;

    try {
        setGlobalLoading(true);

        const config: AxiosRequestConfig = { method, data, params };
        
        const response = await apiInstance.request<ApiResponse>({ url:finalUrl, ...config });
        

        serverRespond = response.data as ApiResponse;

        if(serverRespond.contact){
            console.log(serverRespond.contact,"contact was set")
            contactContext.setContact(serverRespond.contact)
        }
        if(serverRespond.vendor){
            console.log(serverRespond.vendor,"vendor was set")
            vendorContext.setVendor(serverRespond.vendor)
        }
        if(serverRespond.family){
            contactContext.setFamily(serverRespond.family)
        }
        if(serverRespond?.cart?.length> 0){
            contactContext.setCart(serverRespond.cart)
        }
        if(serverRespond.isLogged===false){
            contactContext.setContact(null)
            contactContext.setFamily(null)
            vendorContext.setVendor(null)
        }

    
    } catch (error: any) {
        
      
        serverRespond = error.response?.data as ApiResponse;

        if (serverRespond) {
            const { errorCode, message} = serverRespond;
            console.log(errorCode === 403,"error!@!@")

            if (errorCode === 403 && message === "err_invalid_session" && !secondTry) {
                console.log(error,"error!@!@")
                await createSession();
            
                secondTry = true;
                return await apiCall({ requestType, data, params, secondTry }, setGlobalLoading,contactContext,vendorContext,navigate);
            } 
            if (errorCode === 403 && message === "need to be logged in") {
                if(navigate){
                    contactContext.setAuthNextPage(window.location.pathname)
                    navigate("/login")
                }

            }
        }
    }
    setGlobalLoading(false);
    return serverRespond;
}
